module.exports = __webpack_public_path__ + "img/imgnotavailable.5d6feb95.jpg";